export default "__VITE_ASSET__0cb9a52e__"